var styles = {"rawButton":"styles_raw-button__rWsrL","light":"styles_light__spUP6","dark":"styles_dark__NsAt8"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
